export interface CatalogPaintCutType {
	PaintCutTypeId: number | null;
	PaintCutTypeName: string;
	IsActive: boolean;
	CreatedBy: string | null;
	CreatedDate: Date | null;
	ModifiedBy: string | null;
	ModifiedDate: Date | null;
}

export const CATALOG_PAINT_CUT_TYPE_INITIAL_VALUES: CatalogPaintCutType = {
	PaintCutTypeId: null,
	PaintCutTypeName: "",
	IsActive: true,
	CreatedBy: null,
	CreatedDate: null,
	ModifiedBy: null,
	ModifiedDate: null,
};
